import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as MenuGroupActions from './menu-group.actions';
import {catchError, mergeMap, of} from "rxjs";
import {map} from "rxjs/operators";
import {MenuGroupService} from "../services/menu-group.service";

@Injectable()
export class MenuGroupEffects {


  loadMenuGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MenuGroupActions.loadMenuGroups),
      mergeMap(() =>
        this.menuGroupService.getList().pipe(
          map((menuGroups) => MenuGroupActions.loadMenuGroupsSuccess({menuGroups: menuGroups})),
          catchError((error) =>
            of(MenuGroupActions.loadMenuGroupsFailure({error: error.message}))
          )
        )
      )
    )
  );

  constructor(private readonly actions$: Actions, private readonly menuGroupService: MenuGroupService) {
  }
}
